import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function AdminMeetings() {
  const [items, setItems] = useState([]);
  const refresh = () => api.get("/meetings/").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const update = async (id, status) => { try { await api.put(`/meetings/${id}`, { status }); toast.success("Aggiornato"); refresh(); } catch (e) { toast.error("Errore"); } };
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Call & Incontri</h1>
      <p className="text-sm text-slate-600 mb-6">Discovery, interviste, follow-up, review.</p>
      <div className="space-y-3">
        {items.map(m => (
          <div key={m.id} className="cxo-card p-5 flex items-center gap-4">
            <Calendar size={20} className="text-[#2D6BFF]" />
            <div className="flex-1">
              <p className="font-semibold text-slate-900 capitalize">{m.type}</p>
              <p className="text-sm text-slate-600 cxo-tabular">{m.date} alle {m.time} · {m.duration_minutes} min</p>
              {m.notes && <p className="text-xs text-slate-500 mt-1">{m.notes}</p>}
            </div>
            <Select value={m.status} onValueChange={v => update(m.id, v)}>
              <SelectTrigger className="w-36 h-9 text-xs"><SelectValue /></SelectTrigger>
              <SelectContent>{["scheduled","confirmed","completed","cancelled"].map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
